import React from 'react';
import { toast } from 'react-hot-toast';

import { EpicSummary } from 'types/project/epic';

/**
 * Confirms a new Epic, with a link to its page. The toast is rendered outside the
 * router, so the link navigates through `onView` rather than a <Link>.
 */
export const showEpicCreatedToast = (epic: Pick<EpicSummary, 'epicUuid' | 'workItemKey' | 'title'>, onView: () => void) =>
  toast.success(
    (t) => (
      <div className="flex items-center gap-3">
        <p className="min-w-0">
          Epic <span className="font-semibold">{epic.workItemKey}</span> created
          <span className="block truncate text-xs text-neutral-medium">{epic.title}</span>
        </p>
        <button
          type="button"
          onClick={() => {
            toast.dismiss(t.id);
            onView();
          }}
          className="shrink-0 rounded-md bg-[#8B5CF6] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#7C3AED]"
        >
          View Epic
        </button>
      </div>
    ),
    { id: `epic-created-${epic.epicUuid}`, position: 'top-right', duration: 8000 },
  );
